export const wasThisHelpful = () => {
    // Only include the component if we are viewing the website docs, not the offline docs
    if (location.hostname === 'curity.io') {
        function loadScript(url) {
            return new Promise(function(resolve, reject) {
                let script = document.createElement("script");
                script.src = url;
                script.async = false;
                script.onload = function() {
                    resolve(url);
                };
                script.onerror = function() {
                    reject(url);
                };
                document.body.appendChild(script);
            });
        }

        // Feedback UI
        const showFeedbackBox = () => {
            let isActive = false;
            const feedBackContainer = document.querySelector(".was-this-helpful");

            document.addEventListener("click", function(event) {
                // Yes/No
                if (event.target.name === "feedback_buttons") {
                    isActive = true;
                    feedBackContainer.classList.add("active");
                    window.scrollTo(0, document.documentElement.scrollTop + 400);

                    if (event.target.value === "Yes") {
                        event.target.parentNode.parentNode.nextElementSibling
                            .querySelector("label")
                            .classList.remove("active");
                        event.target.parentElement.classList.add("active");
                    } else {
                        event.target.parentElement.classList.add("active");
                        event.target.parentNode.parentNode.previousElementSibling
                            .querySelector("label")
                            .classList.remove("active");
                    }
                }
                // Close
                if (event.target.className.includes("was-this-helpful-close")) {
                    isActive = false;
                    feedBackContainer.classList.remove("active");
                }
            });
        };

        // Initialize Hubspot form
        const initHubspotForm = () => {
            // Only show feedback form on articles
            const bodyClasses = document.querySelector("body").classList;

            if (!bodyClasses.contains("body-index")) {
                hbspt.forms.create({
                    region: "na1",
                    portalId: "8776208",
                    formId: "f19d7fa2-7f2d-49a1-ba57-4ee5b3eefc20",
                    target: "#was-this-helpful"
                });
            }
        };

        document.addEventListener("DOMContentLoaded", function(event) {
            let scripts = ["//js.hs-scripts.com/8776208.js", "//js.hsforms.net/forms/v2.js"];

            let promises = [];
            scripts.forEach(function(url) {
                promises.push(loadScript(url));
            });

            // Load Hubspot script and form
            Promise.all(promises)
                .then(function() {
                    initHubspotForm();
                    showFeedbackBox();
                })
                .catch(function(script) {
                    console.error(script + " failed to load");
                });
        });
    }
};
